import { Table } from "react-bootstrap";
import { ReviewVideoListItemTrayContentProps } from "./ReviewVideoListItemFooter";
import { useGetVideoClipsQuery } from "../../../../store/api/kinesense";
import ReviewVideoListItemClip from "./ReviewVideoListItemClip";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../store";

export default function ReviewVideoListItemClips(props: ReviewVideoListItemTrayContentProps) {
    const projectId = useSelector((state: ApplicationState) => state.general.activeProjectId);

    const { data } = useGetVideoClipsQuery(
        { projectId: projectId, mediaId: props.data?.mediaId },
        { skip: !projectId || !props.data?.mediaId },
    );
    const clips = data ?? [];

    return (
        <div className="inner">
            <section className="overflow-hidden">
                <div className="overflow-auto" style={{ maxHeight: "30rem", marginLeft: "-0.5rem" }}>
                    {clips.length === 0 && (
                        <p className="text-center text-muted" style={{ marginTop: "0.3rem", marginBottom: "0rem" }}>
                            No clips have been created for this video
                        </p>
                    )}

                    {clips.length > 0 && (
                        <Table borderless className="details-table">
                            <tbody>
                                {clips.map((c) => {
                                    return <ReviewVideoListItemClip key={c.fileId} clip={c} {...props} />;
                                })}
                            </tbody>
                        </Table>
                    )}
                </div>
            </section>
        </div>
    );
}
